import { createStore, combineReducers } from "lib/store/v2";
import { createStoreLogger } from "utils/createStoreLogger";
import { WorkTrackTableInfoActions as WorkTrackTableInfo } from "./TableInfo";
import { WorkTrackActions as WorkTrack } from "./Track";

const reducers = { WorkTrackTableInfo, WorkTrack };
const reducer = combineReducers(reducers, createStoreLogger("WorkTrack"));

export const {
  StoreProvider: TracksStoreProvider,
  useStore: useTracksStore,
  useSelector: useTracksSelector,
  useDispatch: useTracksDispatch
} = createStore(reducer);
